import React from "react";
import hiw1 from "../assets/hiw11.png";
import hiw2 from "../assets/hiw12.png";
import hiw3 from "../assets/hiw13.png";
import avataria from '../assets/avataria.png'
import CallToAction from "./CallToAction";
function HowItWorks() {
    return (
        <div className="how-it-works">
            <div className="container py-3">
                <h2 className="section-title">¿Cómo Funciona?</h2>

                <div style={{padding: "0 50px  0", alignSelf: "center" }}>
                    <div className="row">
                        {/* Step 1 */}
                        <div className="col-md-3 hiw-step d-flex flex-column align-items-center">
                            <div className="hiw_imgcontainer d-flex justify-content-center align-items-center">
                                <img src={hiw1} alt="Asistente AI Como Funciona Paso 1" className="hiwimage" />
                            </div>
                            <div>
                                <ul style={{ listStyleType: "decimal", paddingLeft: "1.2em", textAlign: "center" }}>

                                    <li style={{ textAlign: "left" }}>
                                        <strong>CONTEXTO:</strong> Analizamos en qué parte de tu organización el asistente de IA puede generar mayor valor. ¿En qué procesos clave aporta más? ¿Dónde enfrentas los mayores retos de acceso o gestión de información?
                                    </li>

                                </ul>
                            </div>
                        </div>
                        {/* Step 2 */}
                        <div className="col-md-3 hiw-step d-flex flex-column align-items-center">
                            <div className="hiw_imgcontainer d-flex justify-content-center align-items-center">
                                <img src={hiw2} alt="Asistente AI Como Funciona Paso 2" className="hiwimage" />
                            </div>
                            <div>
                                <ul style={{ listStyleType: "decimal", paddingLeft: "1.2em", textAlign: "center" }}>

                                    <li value="2" style={{ textAlign: "left" }}>
                                        <strong>DIGITALIZACIÓN:</strong> Seleccionamos a la persona dentro de tu organización que desees digitalizar para que represente a la empresa como nuestro próximo avatar virtual.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* Step 3 */}
                        <div className="col-md-3 hiw-step d-flex flex-column align-items-center">
                            <div className="hiw_imgcontainer d-flex justify-content-center align-items-center">
                                <img src={hiw3} alt="Asistente AI Como Funciona Paso 3" className="hiwimage" />
                            </div>
                            <div>
                                <ul style={{ listStyleType: "decimal", paddingLeft: "1.2em", textAlign: "center" }}>

                                    <li value="3" style={{ textAlign: "left" }}>
                                        <strong>ENTRENAMIENTO:</strong> Identificamos el proceso, área o tipo de información que deseas que el avatar domine. Luego, estructuramos ese conocimiento, iteramos y lo validamos contigo
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3 hiw-step d-flex flex-column align-items-center">
                            <div className="hiw_imgcontainer d-flex justify-content-center align-items-center">
                                <img src={avataria} alt="Asistente AI Como Funciona Paso 4" style={{width:"400px"}} />
                            </div>
                            <div>
                                <ul style={{ listStyleType: "decimal", paddingLeft: "1.2em", textAlign: "center" }}>

                                    <li value="4" style={{ textAlign: "left" }}>
                                        <strong>PUESTA EN MARCHA:</strong>  Terminamos tu avatar,  lo entrenamos con la información necesaria y lo preparamos para que empiece a ayudarte con tus clientes en la Pagina Web.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </div>

    );
}

export default HowItWorks;